import '@angular/compiler';
// Trigger rebuild phase 5 complete audit
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

// Trigger rebuild phase 5 fix 22 fix CodeTypeValue component property bindings and normalize MasterData controller
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
